//@ts-nocheck
import React from "react";
import SurveyLandingPageController, {
  Props,
} from "./SurveylandingPageController.web";
import {
  withStyles,
  Typography,
  createStyles,
  ThemeProvider,
  Box,
} from "@material-ui/core";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { withRouter } from "react-router";
import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";
import withDialog from "../../../../components/src/withDialog.web";
import { createTheme } from "@material-ui/core/styles";
import MagicLinkHeader from "./layout/MagicLinkHeader.web";
import MagicLinkButton from "./layout/MagicLinkButton.web";
import { getFirmContactHref } from "./layout/firmContact";
import {
  MAGIC_LINK_CTA,
  magicLinkColors,
  magicLinkLayout,
  magicLinkRadius,
} from "./layout/magicLinkTokens";

export class SurveyLandingPage extends SurveyLandingPageController {
  constructor(props: Props) {
    super(props);
  }
  async componentDidMount() {
    const params = new URLSearchParams(this.props.history.location.search);
    const state = this.props.history.location.state;
    const access_token = params.get("access_token");
    const email = params.get("email");
    const first_name = params.get("first_name");
    const last_name = params.get("last_name");
    const phone_number = params.get("phone_number");
    const account_id = params.get("account_id");
    const surveyLogId = params.get("log");
    const type = params.get("type");
    if (state?.survey_id) {
      this.setState({
        isEnable: true,
      });
    } else {
      this.setState(
        {
          accountId: account_id,
          paymentaccesstoken: access_token,
          clientDetail: {
            email,
            first_name,
            last_name,
            phone_number,
          },
          surveyLogId: surveyLogId,
          type: type,
        },
        () => {
          if (access_token || account_id) {
            this.getCPADetialbyAccessToken();
            this.isEcheckPaymentAvailable();
            if (type != "generalCFS") {
              this.updateSurveyLog();
            }
          }
        }
      );
    }
  }
  navigateToStepperPage = () => {
    this.props.history.push("/startSurveySteps", {
      state: {
        accountId: this.state.accountId,
        cpaDetail: this.state.cpaDetail,
        clientDetail: this.state.clientDetail,
        access_token: this.state.paymentaccesstoken,
        cpaSurveySetting: this.state.cpaSurveySetting,
        surveyLogId: this.state.surveyLogId,
        type: this.state.type,
        isEcheckPaymentAvailable: this.state.IseCheckPaymentAvailable,
      },
    });
  };
  render() {
    const { classes } = this.props;
    const { cpaDetail = { theme: {} } } = this.state;
    const highlights = [
      { id: 1, heading: "Tell us what progress you want to make" },
      { id: 2, heading: "See recommended services and pricing" },
      { id: 3, heading: "Choose to enroll or book a call" },
    ];
    return (
      <ThemeProvider theme={createTheme(this.state.theme)}>
        <Box className={classes.page}>
          <MagicLinkHeader
            logo={cpaDetail?.theme?.logo}
            firmName={cpaDetail?.theme?.firm_name}
            helpHref={getFirmContactHref(cpaDetail?.theme)}
            meetingLink={
              cpaDetail?.survey_setting?.data?.attributes?.meeting_link
            }
          />
          <Box className={classes.content}>
            <Box className={classes.card}>
              <Typography component="h1" className={classes.heading}>
                Get the exact help you need
              </Typography>
              <Typography className={classes.subHeading}>
                In just a few minutes you'll see your personalized package
                options, costs, and how to enroll.
              </Typography>
              <Box className={classes.highlights}>
                {highlights.map((item) => (
                  <Box key={item.id} className={classes.highlight}>
                    <CheckCircleOutlineIcon
                      color="primary"
                      className={classes.highlightIcon}
                    />
                    <Typography className={classes.highlightText}>
                      {item.heading}
                    </Typography>
                  </Box>
                ))}
              </Box>
              <MagicLinkButton
                id="navigateToStepperPage"
                disabled={this.state.isEnable}
                onClick={this.navigateToStepperPage}
                className={classes.startButton}
                style={{
                  backgroundColor:
                    cpaDetail?.theme?.primary_color || MAGIC_LINK_CTA,
                }}
              >
                Start my package
              </MagicLinkButton>
              <Typography className={classes.bottomText}>
                Takes less than 3 minutes
              </Typography>
            </Box>
          </Box>
        </Box>
      </ThemeProvider>
    );
  }
}
const SurveyLandingPageWithRouter = withRouter(SurveyLandingPage);
const SurveyLandingPageWithToast = withToast(SurveyLandingPageWithRouter);
const SurveyLandingPageWithLoader = withLoader(SurveyLandingPageWithToast);
const SurveyLandingPageWithAlertBox = withAlertBox(SurveyLandingPageWithLoader);
const SurveyLandingPageWithDialogBox = withDialog(
  SurveyLandingPageWithAlertBox
);

export default withStyles((theme) =>
  createStyles({
    page: {
      minHeight: "100vh",
      backgroundColor: magicLinkColors.page,
    },
    content: {
      display: "flex",
      justifyContent: "center",
      padding: "128px 24px 24px",
      [theme.breakpoints.down("xs")]: {
        padding: "48px 16px 16px",
      },
    },
    card: {
      width: "100%",
      maxWidth: magicLinkLayout.contentMaxWidth,
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: 24,
      borderRadius: magicLinkRadius.card,
      backgroundColor: magicLinkColors.surface,
    },
    heading: {
      fontFamily: "Nunito Sans",
      fontSize: "24px",
      fontWeight: 600,
      lineHeight: 1,
      color: magicLinkColors.textStrong,
      textAlign: "center",
    },
    subHeading: {
      fontFamily: "Nunito Sans",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: 1.4,
      color: magicLinkColors.text,
      textAlign: "center",
      marginTop: 12,
    },
    highlights: {
      width: "100%",
      maxWidth: 330,
      display: "flex",
      flexDirection: "column",
      gap: 12,
      margin: "12px 0",
      padding: "20px 0",
    },
    highlight: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      minHeight: 44,
      padding: 12,
      boxSizing: "border-box",
      backgroundColor: magicLinkColors.option,
      border: `1px solid ${magicLinkColors.border}`,
      borderRadius: magicLinkRadius.card,
    },
    highlightIcon: {
      fontSize: 16,
    },
    highlightText: {
      fontFamily: "Nunito Sans",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: 1.4,
      color: magicLinkColors.textStrong,
    },
    startButton: {
      width: "100%",
      maxWidth: 330,
      height: 51,
      padding: "12px 18px",
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: 1,
      "&:hover": {
        filter: "brightness(0.92)",
      },
    },
    bottomText: {
      fontFamily: "Nunito Sans",
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: 1,
      color: magicLinkColors.text,
      textAlign: "center",
      marginTop: 12,
    },
  })
)(SurveyLandingPageWithDialogBox);
